import React from "react";
import NewPassword from "../containers/NewPassword";
import NoNavLayout from "../layouts/NoNavLayout";

const NewPasswordPage = props => {
  document.title = props.title;
  return (
    <NoNavLayout>
      <NewPassword />
    </NoNavLayout>
  );
};

export default NewPasswordPage;






// WEBPACK FOOTER //
// ./src/pages/NewPasswordPage.js